<template>
<div :class="computedClass">
  <label
    class="text-label"
    :class="{'no-padding': helpIcon}"
    :for="name"
    v-if="label"
  >
    {{ label }} <em class="optional" v-if="!required">optional</em><em class="required" v-if="required">*</em>
    <help-icon
      v-if="helpIcon"
      :popperOptions="helpIconOptions"
      size="small"
    />
  </label>
  <div class="flex">
    <input
      v-if="type == 'text'"
      :readonly="readonly"
      :optional="!required"
      type="text"
      v-model="newValue"
      class="field--input text-input"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
    >
    <input v-if="type == 'email'" :readonly="readonly" :optional="!required" type="email" v-model="newValue" class="field--input text-input" :id="name" :name="name" :disabled="disabled" :placeholder="placeholder">
    <textarea v-if="type == 'textarea'" :optional="!required" v-model="newValue" class="field--input textarea-input" :id="name" :name="name" :placeholder="placeholder" :disabled="disabled"></textarea>
    <input v-if="type == 'password'" v-model="newValue" class="field--input password-input" :id="name" :name="name" type="password" :placeholder="placeholder" :disabled="disabled">
  </div>
  <div v-if="type == 'select'" class="field--wrapper input--select-wrapper">
    <select :disabled="readonly || disabled" @change="onChange($event)" class="field--input field--select input--select" v-model="newValue" :id="name" :name="name">
      <option :value="undefined" disabled style="display:none"></option>
      <option v-for="option in collection" :disabled="(option.disabled == 'true')" :key="option.value" :name="option.value" :selected="option.value == newValue" :value="option.value">
        {{option.name}}
      </option>
    </select>
  </div>

  <div v-if="type == 'radio'" class="field--wrapper">
    <div v-for="option in collection" :key="option.value" class="field--radio">
      <input
        type="radio"
        class="input--radio"
        v-model="newValue"
        :name="name"
        :value="option.value"
        :id="name + '-' + option.value"
        :checked="option.value == newValue"
        @click="onClick(option.value)"
        :item="value"
        ref='input'
        :disabled="disabled"
      >
      <label
        :for="name + '-' + option.value">{{option.name}}</label>
    </div>
  </div>

  <div v-if="type == 'checkbox'" class="field--wrapper">
    <div v-for="option in collection" :key="option.value" class="field--checkbox">
      <input type="checkbox" class="input--checkbox" v-model="newValue" :value="option.value" :id="name + '-' + option.value" :item="value" checked :disabled="disabled" @click="onClick(option.value)">
      <label :for="name + '-' + option.value">{{option.name}}</label>
    </div>
  </div>

  <p v-if="error" class="validation-message">{{error}}</p>

</div>
</template>
<script>
import HelpIcon from '@/components/helpers/DataDisplay/HelpIcon'
export default {
  props: {
    classes: [ Array, String ],
    label: String,
    name: String,
    value: {},
    autocomplete: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helpIcon: {
      type: Boolean,
      default: false
    },
    helpIconOptions: {
      type: Object
    },
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: null
    },
    collection: {},
    error: String,
    enrich_tags: false
  },
  components: {
    HelpIcon
  },
  data () {
    return {
      newValue: '',
      newValues: [],
      oldValue: null,
      tagEnrichmentInitiated: false
    }
  },
  computed: {
    computedClass () {
      if (typeof this.classes === 'string') {
        return this.classes
      } else {
        let str = 'field field-' + this.type
        if (this.classes) {
          if (Array.isArray(this.classes)) {
            str += ' ' + this.classes.toString(' ')
          }
        }
        if (this.error !== undefined) {
          str += ' is-unvalid'
        }
        if (this.required === false) {
          str += ' is-optional'
        } else {
          str += ' is-required'
        }
        if (this.readonly === true || this.disabled === true) {
          str += ' is-disabled'
        }
        if (this.autofocus === true) {
          str += ' is-autofocused'
        }
        return str
      }
    },
  },
  mounted () {

    // Set focus on the first text element
    // I'm not sure why the setTimeout() is necessary, but otherwise the element won't receive focus
    let firstInput = document.querySelector('.is-autofocused .text-input, .textarea-input, .field--select')
    if (firstInput != null) {
      setTimeout(() => {
        firstInput.focus()
      }, 0)
    }

    if (this.value) {
      this.newValue = this.value
    } else {
      this.newValue = this.defaultValue
    }
  },
  methods: {
    onChange(event) {
      let clickedValue = event.target.value

      if(this.enrich_tags) {
        this.enrichTags(clickedValue)
      }
    },
    onClick(value) {
      let clickedValue = event.target.value
      // If type is radio we want to allow user to unselect the field by clicking on the selected field again.
      if (this.type === 'radio') {
        if (this.oldValue === clickedValue) {
          this.resetField()
        } else {
          // this is needed to remove the old value
          if(this.enrich_tags) {
            this.enrichTags(this.oldValue)
          }
          this.oldValue = clickedValue
        }
      }
      if(this.enrich_tags) {
        this.enrichTags(clickedValue)
      }
    },
    resetField() {
      this.oldValue = null
      this.newValue = this.defaultValue
    },
    // if we want to enrich tags we have to update the tag list accordingly to avoid unnecessary parameters
    // we enrich tags on watched and we enrich on each new click
    // NOTE: tags should get enriched on mounted but there is a problem with "this.value" not being available
    // this can mean we also remove enriched tags, if they already exist in the tags array
    enrichTags(value, removeIfExists = true) {
      this.tagEnrichmentInitiated = true
      EventBus.$emit('enrich_tags', value, removeIfExists)
    }
  },
  watch: {
    value (val) {
      if (val !== this.newValue) {
        this.newValue = val

        // init old value for radios
        if (this.type === 'radio') {
          this.oldValue = val
        }
      }
    },
    newValue (newVal) {

      // enrich tags in tag-list component
      if(this.newValue) {
        if(this.enrich_tags && !this.tagEnrichmentInitiated) {
          let value = []
          if (typeof this.newValue == 'string') {
            value = this.newValue.split(' ')
          } else if (Array.isArray(this.newValue)) {
            value = this.newValue
          }
          EventBus.$emit('enrich_tags_on_init', value)
          this.tagEnrichmentInitiated = true
        }
      }

      // Initialized and with no default value text type field is (null). When we type content and remove it, it becames an empty string & save pop-up still showing
      // To be able to untrack these changes we remove "" and we reemplace it with defaultValue (null as default).
      // * There was a problem When newVal was boolean and false. It was overwritting the checkbox from false to the default value.
      if (!newVal && (typeof newVal !== 'boolean' )) {
        this.newValue = this.defaultValue
        newVal        = this.defaultValue
      }
      this.$emit('input', newVal)
    },
    newValues (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormField.vue?d684226a